/**
 * Alpine.js component for the moderator incognito switch.
 *
 * The endpoint answers with the stored state, so `invisible` follows the server.
 *
 * Usage in Twig:
 *   <button x-data="modInvisibleToggle({{ currentUser.invisible ? 'true' : 'false' }}, '{{ links.getModInvisibleToggle() }}')"
 *           @click.prevent="toggle()">
 */
export function modInvisibleToggle(isInvisible = false, url = '') {
    return {
        invisible: isInvisible,
        loading: false,

        toggle() {
            if (this.loading) return;
            this.loading = true;
            const params = new URLSearchParams();
            params.append('stat', this.invisible ? '1' : '0');
            fetch(url, {
                method: 'POST',
                body: params,
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            })
                .then((r) => (r.ok ? r.text() : Promise.reject()))
                .then((t) => { this.invisible = t.trim() === '1'; })
                .catch(() => {})
                .finally(() => { this.loading = false; });
        },
    };
}
